import React, { Component } from 'react';
import {retrieveAllBackups, restore} from "../../util/ApiUtils";
import {Route} from "react-router-dom";
import {ACCESS_TOKEN, V1_API_URL_PREFIX} from "../../Constants";
import {NotificationManager} from "react-notifications";
import { t } from '../../i18n';

class Admin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fileNames: [],
            message: null
        };
    }

    submit() {
        let companyname = document.getElementById("companyname");
        let firstname = document.getElementById("firstname");
        let lastname = document.getElementById("lastname");
        let useremailaddress = document.getElementById("useremailaddress");
        let trial_end_date = document.getElementById("trial_end_date");
        let password = document.getElementById("password");
        let language = document.getElementById("language");
        let languageValue = "en";
        if (!language || language.value === "") {
            languageValue = "en";
        } else {
            languageValue = language.value;
        }
        console.log("data", [companyname, firstname, lastname, useremailaddress, trial_end_date, password, languageValue]);
        if (
            companyname && companyname.value !== '' &&
            firstname && firstname.value !== '' &&
            lastname && lastname.value !== '' &&
            useremailaddress && useremailaddress.value !== '' &&
            password && password.value !== ''
        ) {
            console.log("valid");
            const headers = new Headers({
                'Content-Type': 'application/json',
            });

            if (localStorage.getItem(ACCESS_TOKEN)) {
                headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
            }

            const defaults = {headers: headers};
            let options = Object.assign({}, defaults, {
                url: V1_API_URL_PREFIX + "/admin/new-client",
                method: 'POST',
                body: JSON.stringify({
                    companyname: companyname.value,
                    firstname: firstname.value,
                    lastname: lastname.value,
                    useremailaddress: useremailaddress.value,
                    trial_end_date: trial_end_date.value,
                    password: password.value,
                    language: languageValue
                })
            });
            return fetch(options.url, options)
                .then(response => {
                        if (response.status !== 200) {
                            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
                            return Promise.reject();
                        }
                        document.getElementById("companyname").value = "";
                        document.getElementById("firstname").value = "";
                        document.getElementById("lastname").value = "";
                        document.getElementById("useremailaddress").value = "";
                        document.getElementById("trial_end_date").value = "";
                        document.getElementById("password").value = "";
                        document.getElementById("language").value = "";
                        NotificationManager.success(t('app.notifications.success'), t('messages.clientRegistered'), 5000);
                        return Promise.resolve();
                    }
                );
        } else {
            console.log("invalid");
            NotificationManager.error(t('app.notifications.error'), t('messages.validationErrorFields'), 5000);
        }
    }

    render() {
        return (
            <Route path={`/admin/new-client` }>
            <div className="container" style={{ textAlign: "center" }}>
                <h3>{ t('admin.newClient.title') }</h3>
                <div className="container">
                    <table className="table" style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <tbody style={{ textAlign: "right"}}>
                        <tr>
                            <td>{ t('admin.newClient.companyNameLabel') } <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="companyname" id="companyname"/></td>
                        </tr>
                        <tr>
                            <td>{ t('admin.newClient.firstNameLabel') } <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="firstname" id="firstname"/></td>
                        </tr>
                        <tr>
                            <td>{ t('admin.newClient.lastNameLabel') } <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="lastname" id="lastname"/></td>
                        </tr>
                        <tr>
                            <td>{ t('admin.newClient.emailLabel') } <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="useremailaddress" id="useremailaddress"/></td>
                        </tr>
                        <tr>
                            <td>{ t('admin.newClient.trialEndDateLabel') }</td>
                            <td><input type="text" name="trial_end_date" id="trial_end_date"/></td>
                        </tr>
                        <tr>
                            <td>{ t('admin.newClient.passwordLabel') } <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="password" id="password"/></td>
                        </tr>
                        <tr>
                            <td>{ t('admin.newClient.languageLabel') }</td>
                            <td><input type="text" name="language" id="language"/></td>
                        </tr>
                        <tr style={{ textAlign: "left"}}>
                            <td></td>
                            <td><button type="submit" onClick={ this.submit }>{ t('admin.newClient.addButton') }</button></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </Route>
        )
    }
}

export default Admin;